import React, { useState, useEffect } from "react";
import {
  TreeView,
  processTreeViewItems,
  handleTreeViewCheckChange,
} from "@progress/kendo-react-treeview";
import { useDispatch, useSelector } from "react-redux";
import { getLocationData } from "redux-store/locations/actions";
import SoftTypography from "components/SoftTypography";
import Skeleton from "@mui/material/Skeleton";
import SoftBox from "components/SoftBox";
import { Grid } from "@mui/material";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const selectField = "selected";
const expandField = "expanded";
const dataItemKey = "id";
const textField = "text";
const subItemsField = "items";
const fields = {
  selectField,
  expandField,
  dataItemKey,
  subItemsField,
};


const tree = [
  {
    text: "Ciocca_VW_Dryer",
    items: [
      {
        text: "Temp",
      },
      {
        text: "Dewpoint",
      },
      {
        text: "Pressure",
      },
      {
        text: "Flow",
      },
    ],
  },
  {
    text: "68B6B33DB0DC",
    items: [
      {
        text: "Input 1",
      },
      {
        text: "Input 2",
      },
      {
        text: "Input 3",
      },
      {
        text: "Input 4",
      },
    ],
  },
  {
    text: "Ciocca_Honda_AC1",
    items: [
      {
        text: "Voltage",
      },
      {
        text: "Current",
      },
      {
        text: "Energy",
      },
    ],
  },
  {
    text: "Ciocca_Subfeed",
    items: [
      {
        text: "Voltage",
      },
      {
        text: "Current",
      },
      {
        text: "Energy",
      },
    ],
  },
];

const AssetsTreeList = ({
  selectedIndex,
  setSelectedIndex,
  selectedNode,
  setSelectedNode,
  refresh,
}) => {
  const dispatch = useDispatch();
  const { loading, error, data } = useSelector((state) => state.location.getLocationData);

  useEffect(() => {
    dispatch(getLocationData());
  }, [refresh]);

  const [value, setValue] = useState(null);
  const [expanded, setExpanded] = useState([]);
  const onChange = (event) => setValue(event.value);

  const treeData = processTreeViewItems(data?.locationTree || [], { expanded, value }, fields);

  const [check, setCheck] = React.useState([]);
  const [expand, setExpand] = React.useState({
    ids: ["Item2"],
    idField: "text",
  });

  const onItemClick = (event) => {
    setSelectedIndex([event.itemHierarchicalIndex]);
    setSelectedNode(event.item);
  };

  const onExpandChange = (event) => {
    const ids = expand.ids ? expand.ids.slice() : [];
    const index = ids.indexOf(event.item.text);
    index === -1 ? ids.push(event.item.text) : ids.splice(index, 1);
    setExpand({
      ids,
      idField: "text",
    });
  };
  const onCheckChange = (event) => {
    const settings = {
      singleMode: false,
      checkChildren: false,
      checkParents: false,
    };
    setCheck(handleTreeViewCheckChange(event, check, treeData, settings));
  };

  return (
    <SoftBox>
      {loading ? (
        <Skeleton variant="rectangular" height={400} />
      ) : data && data.locationTree && data.locationTree.length > 0 ? (
        <Grid paddingLeft={3} paddingBottom={3}>
          {/* <SoftTypography variant="h6" color="text">
            Location listing
          </SoftTypography> */}
          <TreeView
            data={processTreeViewItems(tree, {
              select: selectedIndex,
              check: check,
              expand: expand,
            })}
            expandIcons={true}
            onExpandChange={onExpandChange}
            aria-multiselectable={true}
            onItemClick={onItemClick}
            checkboxes={false}
            onCheckChange={onCheckChange}
            filterable={true}
          />
        </Grid>
      ) : (
        <SoftTypography px={3} pb={3} variant="body1" color="textSecondary">
          No records found. Please add your locations.
        </SoftTypography>
      )}
    </SoftBox>
  );
};

export default AssetsTreeList;
